/**
 * German translations, keyed by the English source text.
 * Missing keys fall back to English; i18n.test.ts checks that every key is translated.
 */
export const de: Record<string, string> = {
  "1 = single, 3 = triple running stitch": "1 = einfach, 3 = dreifacher Geradstich",
  "100 stitches back": "100 Stiche zurück",
  "100 stitches forward": "100 Stiche vor",
  "360 × 350 mm (commercial)": "360 × 350 mm (Industrie)",
  "Action for the colour": "Aktion für die Farbe",
  "Add the image as a background and draw the shapes yourself": "Bild als Hintergrund einfügen und die Formen selbst zeichnen",
  "Add to the design": "Zum Design hinzufügen",
  "Analysing colours": "Farben werden analysiert",
  "Analysing…": "Analysiere…",
  "Applies to the visible motif (background and transparency removed). The aspect ratio is kept.": "Gilt für das sichtbare Motiv (Hintergrund und Transparenz entfernt). Das Seitenverhältnis bleibt erhalten.",
  "Appliqué on fabric (twill)": "Applikation auf Stoff (Twill)",
  "Area": "Fläche",
  "Automatic": "Automatisch",
  "Autosave failed: {msg}. Save the project manually or download the project file.": "Automatisches Speichern fehlgeschlagen: {msg}. Speichern Sie das Projekt manuell oder laden Sie die Projektdatei herunter.",
  "Background": "Hintergrund",
  "Background colour": "Hintergrundfarbe",
  "Black": "Schwarz",
  "Border": "Rand",
  "Border colour": "Randfarbe",
  "Border width (satin)": "Randbreite (Satin)",
  "Brother and Baby Lock": "Brother und Baby Lock",
  "Brother and Baby Lock, PE-Design 6 and newer": "Brother und Baby Lock, PE-Design 6 und neuer",
  "By the machine's jump setting": "Nach der Sprungeinstellung der Maschine",
  "Cancel": "Abbrechen",
  "Cancel digitizing": "Digitalisierung abbrechen",
  "Canvas layers": "Ebenen der Arbeitsfläche",
  "Centre X": "Mitte X",
  "Centre Y": "Mitte Y",
  "Centre on the design": "Auf das Design zentrieren",
  "Centre run": "Mittellinie",
  "Centre the design in the hoop": "Design im Rahmen zentrieren",
  "Changes to the current project are not saved. Discard them?": "Änderungen am aktuellen Projekt sind nicht gespeichert. Verwerfen?",
  "Checking…": "Prüfe…",
  "Choose another image": "Anderes Bild wählen",
  "Choose colour…": "Farbe wählen…",
  "Choose end point": "Endpunkt wählen",
  "Choose or drop an image file": "Bilddatei wählen oder ablegen",
  "Choose start point": "Startpunkt wählen",
  "Circle": "Kreis",
  "Cleaning up colour regions": "Farbbereiche werden bereinigt",
  "Clear selection": "Auswahl aufheben",
  "Click for actual size (100 %)": "Klicken für tatsächliche Größe (100 %)",
  "Click on the canvas to choose the end point · Esc cancels": "Auf die Arbeitsfläche klicken, um den Endpunkt zu wählen · Esc bricht ab",
  "Click on the canvas to choose the hoop centre · Esc cancels": "Auf die Arbeitsfläche klicken, um die Rahmenmitte zu wählen · Esc bricht ab",
  "Click on the canvas to choose the start point · Esc cancels": "Auf die Arbeitsfläche klicken, um den Startpunkt zu wählen · Esc bricht ab",
  "Close": "Schließen",
  "Close dialog": "Dialog schließen",
  "Close message": "Meldung schließen",
  "Closed line": "Geschlossene Linie",
  "Colour": "Farbe",
  "Colour changes": "Farbwechsel",
  "Colour for all": "Farbe für alle",
  "Colour for {name}": "Farbe für {name}",
  "Colour name": "Farbname",
  "Colour separation": "Farbtrennung",
  "Colour {n}": "Farbe {n}",
  "Colour: {name}. Change colour": "Farbe: {name}. Farbe ändern",
  "Colours": "Farben",
  "Colours and background": "Farben und Hintergrund",
  "Colours are stored as the nearest colour in Brother's 64-colour PEC palette.": "Farben werden als nächstgelegene Farbe der PEC-Palette von Brother mit 64 Farben gespeichert.",
  "Colours are stored as the nearest colour in Janome's palette.": "Farben werden als nächstgelegene Farbe der Janome-Palette gespeichert.",
  "Column": "Säule",
  "Command": "Befehl",
  "Command {n} of {total}": "Befehl {n} von {total}",
  "Corner radius": "Eckenradius",
  "Could not write {format}: {error}": "{format} konnte nicht geschrieben werden: {error}",
  "Creating embroidery objects": "Stickobjekte werden erstellt",
  "Crop area": "Zuschnittbereich",
  "Custom": "Benutzerdefiniert",
  "Custom centre point": "Benutzerdefinierter Mittelpunkt",
  "Custom…": "Benutzerdefiniert…",
  "DST displacement outside ±121: ({dx}, {dy})": "DST-Verschiebung außerhalb ±121: ({dx}, {dy})",
  "DST does not store thread colours – only colour changes. Choose the colours on the machine.": "DST speichert keine Garnfarben – nur Farbwechsel. Wählen Sie die Farben an der Maschine.",
  "Delete": "Löschen",
  "Density (spacing, same side)": "Dichte (Abstand, gleiche Seite)",
  "Design canvas": "Arbeitsfläche",
  "Design size": "Designgröße",
  "Design statistics": "Designstatistik",
  "Diameter": "Durchmesser",
  "Digitize automatically": "Automatisch digitalisieren",
  "Digitized: {n} objects in {c} colours.": "Digitalisiert: {n} Objekte in {c} Farben.",
  "Dimensions": "Abmessungen",
  "Distance to the design": "Abstand zum Design",
  "Do not sew (remove)": "Nicht sticken (entfernen)",
  "Done": "Fertig",
  "Double-click to rename": "Doppelklicken zum Umbenennen",
  "Download as project file": "Als Projektdatei herunterladen",
  "Drag to move · Delete removes (min. {n} points) · double-click an edge to add": "Ziehen zum Verschieben · Entf löscht (mind. {n} Punkte) · Doppelklick auf eine Kante fügt hinzu",
  "Draw a shape": "Form zeichnen",
  "Drop an image here, or click to choose": "Bild hier ablegen oder klicken zum Auswählen",
  "Duplicate": "Duplizieren",
  "EXP displacement outside ±127: {v}": "EXP-Verschiebung außerhalb ±127: {v}",
  "EXP does not store thread colours – only colour changes.": "EXP speichert keine Garnfarben – nur Farbwechsel.",
  "Earlier": "Früher",
  "Edge run": "Randlinie",
  "Edit": "Bearbeiten",
  "Edit nodes": "Knoten bearbeiten",
  "Editable shapes": "Bearbeitbare Formen",
  "Ellipse (fill)": "Ellipse (Füllung)",
  "Embedded images in the SVG were skipped.": "Eingebettete Bilder in der SVG-Datei wurden übersprungen.",
  "Error": "Fehler",
  "Estimate based on the machine settings": "Schätzung anhand der Maschineneinstellungen",
  "Exact RGB colours": "Exakte RGB-Farben",
  "Expected VP3 block 00 0{tag} 00 at byte {pos}.": "VP3-Block 00 0{tag} 00 bei Byte {pos} erwartet.",
  "Expected a CEmbOne block.": "CEmbOne-Block erwartet.",
  "Expected a CSewSeg block.": "CSewSeg-Block erwartet.",
  "Export": "Exportieren",
  "Export embroidery file": "Stickdatei exportieren",
  "File format": "Dateiformat",
  "File size": "Dateigröße",
  "Fill": "Füllung",
  "Fill angle": "Füllwinkel",
  "Fill stitch needs a closed shape. Close the line or use running stitch.": "Füllstich benötigt eine geschlossene Form. Schließen Sie die Linie oder verwenden Sie Geradstich.",
  "Fill {n}": "Füllung {n}",
  "First": "Zuerst",
  "Fit to window (F)": "An Fenster anpassen (F)",
  "Follow the design": "Dem Design folgen",
  "Fully embroidered (filled background)": "Vollgestickt (gefüllter Hintergrund)",
  "Generated stitches": "Erzeugte Stiche",
  "Generating stitches…": "Stiche werden erzeugt…",
  "Gradients are not supported; the first colour stop is used.": "Farbverläufe werden nicht unterstützt; der erste Farbstopp wird verwendet.",
  "Group objects by colour": "Objekte nach Farbe gruppieren",
  "Grows the shape so it overlaps neighbouring objects": "Vergrößert die Form, sodass sie benachbarte Objekte überlappt",
  "Has a warning": "Hat eine Warnung",
  "Has errors": "Hat Fehler",
  "Height": "Höhe",
  "Height (stitches)": "Höhe (Stiche)",
  "Hidden objects are not sewn and are not included in the export": "Ausgeblendete Objekte werden nicht gestickt und nicht exportiert",
  "Hide (do not sew)": "Ausblenden (nicht sticken)",
  "Hide – the object is not sewn and not included in the export": "Ausblenden – das Objekt wird nicht gestickt und nicht exportiert",
  "Hoop": "Rahmen",
  "Hoop (sewing field)": "Rahmen (Stickfeld)",
  "Hoop and placement": "Rahmen und Platzierung",
  "Hoop height": "Rahmenhöhe",
  "Hoop width": "Rahmenbreite",
  "Image": "Bild",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools on the left.": "Importieren Sie ein Bild (PNG, JPEG oder SVG) zur automatischen Digitalisierung oder zeichnen Sie Formen selbst mit den Werkzeugen links.",
  "Import an image for automatic digitizing, or draw shapes with the tools.": "Importieren Sie ein Bild zur automatischen Digitalisierung oder zeichnen Sie Formen mit den Werkzeugen.",
  "Import as vector shapes": "Als Vektorformen importieren",
  "Import image": "Bild importieren",
  "Import project file": "Projektdatei importieren",
  "Imported {n} vector shapes in {c} colours.": "{n} Vektorformen in {c} Farben importiert.",
  "Imported “{name}”. Save it to keep it in the browser.": "„{name}“ importiert. Speichern Sie es, um es im Browser zu behalten.",
  "Info": "Info",
  "Inset": "Einzug",
  "Internal error in DST encoding": "Interner Fehler bei der DST-Kodierung",
  "Invalid PEC offset in the PES file.": "Ungültiger PEC-Offset in der PES-Datei.",
  "Invalid PEC stitch block signature.": "Ungültige Signatur des PEC-Stichblocks.",
  "Invalid VP3 stitch block.": "Ungültiger VP3-Stichblock.",
  "Invalid coordinates were generated. Check the shape.": "Es wurden ungültige Koordinaten erzeugt. Prüfen Sie die Form.",
  "Invalid image data.": "Ungültige Bilddaten.",
  "Invalid long VP3 displacement.": "Ungültige lange VP3-Verschiebung.",
  "Invalid path data in SVG.": "Ungültige Pfaddaten in der SVG-Datei.",
  "Invalid position {pos}": "Ungültige Position {pos}",
  "Invalid project: {msg}": "Ungültiges Projekt: {msg}",
  "Invalid section separator in CSewSeg.": "Ungültiges Abschnittstrennzeichen in CSewSeg.",
  "Invalid start of the PEC stitch block.": "Ungültiger Anfang des PEC-Stichblocks.",
  "Invalid stitch offset in the JEF header.": "Ungültiger Stich-Offset im JEF-Header.",
  "JEF displacement outside ±127: {v}": "JEF-Verschiebung außerhalb ±127: {v}",
  "JEF export does not support stops without a colour change.": "Der JEF-Export unterstützt keine Stopps ohne Farbwechsel.",
  "JEF has no trim command; the machine trims jumps according to its own setting.": "JEF hat keinen Schneidebefehl; die Maschine schneidet Sprünge nach ihrer eigenen Einstellung.",
  "Janome, Elna and Kenmore": "Janome, Elna und Kenmore",
  "Jump records": "Sprungeinträge",
  "Jump sequence (Tajima convention)": "Sprungfolge (Tajima-Konvention)",
  "Jumps": "Sprünge",
  "Jumps and trims": "Sprünge und Schnitte",
  "Keep aspect ratio": "Seitenverhältnis beibehalten",
  "Language": "Sprache",
  "Last": "Zuletzt",
  "Later": "Später",
  "Line": "Linie",
  "Line (running stitch)": "Linie (Geradstich)",
  "Line {n}": "Linie {n}",
  "Loading …": "Wird geladen …",
  "Lock": "Sperren",
  "Lock against editing": "Gegen Bearbeitung sperren",
  "Lock aspect ratio": "Seitenverhältnis sperren",
  "Lock object": "Objekt sperren",
  "Machine": "Maschine",
  "Make a patch (badge) around the design": "Aufnäher (Patch) um das Design erstellen",
  "Make patch": "Aufnäher erstellen",
  "Manual: use as background": "Manuell: als Hintergrund verwenden",
  "Max stitch length": "Max. Stichlänge",
  "Max width before split": "Max. Breite vor Teilung",
  "Melco/Bernina and compatibles": "Melco/Bernina und kompatible",
  "Merge": "Zusammenführen",
  "Merge with another colour": "Mit einer anderen Farbe zusammenführen",
  "Merge with {colour}": "Mit {colour} zusammenführen",
  "Method": "Methode",
  "Minimum stitch length": "Minimale Stichlänge",
  "Minimum stitch length cannot be larger than the stitch length.": "Die minimale Stichlänge darf nicht größer als die Stichlänge sein.",
  "Missing migration from version {v}.": "Fehlende Migration von Version {v}.",
  "Mixed": "Gemischt",
  "More…": "Mehr…",
  "Move all objects to:": "Alle Objekte verschieben nach:",
  "Move colour up": "Farbe nach oben verschieben",
  "Move end point": "Endpunkt verschieben",
  "Move start point": "Startpunkt verschieben",
  "Move up": "Nach oben",
  "Nearest colour in the machine palette": "Nächste Farbe der Maschinenpalette",
  "New colour": "Neue Farbe",
  "New project": "Neues Projekt",
  "No colours (colour changes only)": "Keine Farben (nur Farbwechsel)",
  "No objects selected": "Keine Objekte ausgewählt",
  "No objects yet": "Noch keine Objekte",
  "No preview": "Keine Vorschau",
  "No saved projects": "Keine gespeicherten Projekte",
  "No shapes found in the SVG file. Text must be converted to outlines before importing.": "Keine Formen in der SVG-Datei gefunden. Text muss vor dem Import in Konturen umgewandelt werden.",
  "No stitches to show. Add objects first.": "Keine Stiche zum Anzeigen. Fügen Sie zuerst Objekte hinzu.",
  "No stitches yet": "Noch keine Stiche",
  "Not a PEC file.": "Keine PEC-Datei.",
  "Not a PES file (missing the #PES signature).": "Keine PES-Datei (#PES-Signatur fehlt).",
  "Not a VP3 file (missing %vsm%).": "Keine VP3-Datei (%vsm% fehlt).",
  "Number of colours": "Anzahl der Farben",
  "Object": "Objekt",
  "Object list": "Objektliste",
  "Object name": "Objektname",
  "Object {n}": "Objekt {n}",
  "Objects": "Objekte",
  "Objects are sewn in list order. Grouping by colour (in palette order) gives the fewest colour changes, but may change which objects end up on top.": "Objekte werden in Listenreihenfolge gestickt. Gruppieren nach Farbe (in Palettenreihenfolge) ergibt die wenigsten Farbwechsel, kann aber ändern, welche Objekte oben liegen.",
  "Objects in sewing order": "Objekte in Stickreihenfolge",
  "Objects · sewing order": "Objekte · Stickreihenfolge",
  "One stitch back": "Ein Stich zurück",
  "One stitch forward": "Ein Stich vor",
  "Open {name}": "{name} öffnen",
  "Order": "Reihenfolge",
  "Original image": "Originalbild",
  "Original · drag to crop": "Original · ziehen zum Zuschneiden",
  "Oval": "Oval",
  "Overlap": "Überlappung",
  "Own trim command": "Eigener Schneidebefehl",
  "PEC displacement outside ±2047: {v}": "PEC-Verschiebung außerhalb ±2047: {v}",
  "PEC/PES does not support stop commands without a colour change.": "PEC/PES unterstützt keine Stoppbefehle ohne Farbwechsel.",
  "PES does not support stop commands without a colour change.": "PES unterstützt keine Stoppbefehle ohne Farbwechsel.",
  "PES supports at most 255 colour blocks.": "PES unterstützt höchstens 255 Farbblöcke.",
  "PES v6 stores the exact thread colours and names in the file. The machine sews from the PEC part, which shows the nearest Brother colour.": "PES v6 speichert die exakten Garnfarben und -namen in der Datei. Die Maschine stickt aus dem PEC-Teil, der die nächste Brother-Farbe anzeigt.",
  "PNG, JPEG or SVG, max 25 MB. The image is processed only in your browser and is never uploaded. Transparency in PNG and SVG is used as background.": "PNG, JPEG oder SVG, max. 25 MB. Das Bild wird nur in Ihrem Browser verarbeitet und nie hochgeladen. Transparenz in PNG und SVG wird als Hintergrund verwendet.",
  "Pan": "Verschieben",
  "Parts of the design are outside the hoop with the chosen placement. Centre the design in the hoop.": "Teile des Designs liegen bei der gewählten Platzierung außerhalb des Rahmens. Zentrieren Sie das Design im Rahmen.",
  "Passes": "Durchgänge",
  "Passes must be a whole number.": "Durchgänge müssen eine ganze Zahl sein.",
  "Patch": "Aufnäher",
  "Patch added. The machine stops after the placement line (lay the fabric) and after the tack-down (trim away the excess).": "Aufnäher hinzugefügt. Die Maschine stoppt nach der Platzierungslinie (Stoff auflegen) und nach dem Heftstich (Überstand abschneiden).",
  "Patch added: background, design and satin border.": "Aufnäher hinzugefügt: Hintergrund, Design und Satinrand.",
  "Patch preview": "Vorschau des Aufnähers",
  "Patch shape": "Form des Aufnähers",
  "Patch – background": "Aufnäher – Hintergrund",
  "Patch – border": "Aufnäher – Rand",
  "Patch – placement (stop)": "Aufnäher – Platzierung (Stopp)",
  "Patch – placement line": "Aufnäher – Platzierungslinie",
  "Patch – satin border": "Aufnäher – Satinrand",
  "Patch – tack-down": "Aufnäher – Heftstich",
  "Patch – tack-down (stop)": "Aufnäher – Heftstich (Stopp)",
  "Pause": "Pause",
  "Pfaff and Husqvarna Viking": "Pfaff und Husqvarna Viking",
  "Placement line → stop (lay the fabric) → tack-down → stop (trim away the fabric outside) → design → satin border.": "Platzierungslinie → Stopp (Stoff auflegen) → Heftstich → Stopp (Stoff außen abschneiden) → Design → Satinrand.",
  "Play": "Abspielen",
  "Polygon (fill)": "Polygon (Füllung)",
  "Position": "Position",
  "Position and size": "Position und Größe",
  "Preview of the colour separation": "Vorschau der Farbtrennung",
  "Project name": "Projektname",
  "Project not found.": "Projekt nicht gefunden.",
  "Project not found. It may have been deleted.": "Projekt nicht gefunden. Es wurde möglicherweise gelöscht.",
  "Projects": "Projekte",
  "Projects are stored only in this browser (IndexedDB). Download the project file as a backup or to move the project to another computer.": "Projekte werden nur in diesem Browser gespeichert (IndexedDB). Laden Sie die Projektdatei als Sicherung herunter oder um das Projekt auf einen anderen Computer zu übertragen.",
  "Projects on this device": "Projekte auf diesem Gerät",
  "Properties": "Eigenschaften",
  "Pull compensation": "Zugkompensation",
  "Reading the image…": "Bild wird gelesen…",
  "Ready for export": "Bereit zum Export",
  "Rectangle": "Rechteck",
  "Rectangle (fill)": "Rechteck (Füllung)",
  "Redo": "Wiederholen",
  "Remaining ≈ {time} (estimate)": "Verbleibend ≈ {time} (Schätzung)",
  "Remove patch": "Aufnäher entfernen",
  "Remove solid background": "Einfarbigen Hintergrund entfernen",
  "Remove unused": "Unbenutzte entfernen",
  "Removed: {colour}": "Entfernt: {colour}",
  "Rename": "Umbenennen",
  "Replace the existing design": "Bestehendes Design ersetzen",
  "Reset crop": "Zuschnitt zurücksetzen",
  "Rotate (Shift = 15° steps)": "Drehen (Umschalt = 15°-Schritte)",
  "Rotation": "Drehung",
  "Rounded rectangle": "Abgerundetes Rechteck",
  "Row spacing": "Reihenabstand",
  "Row spacing (density)": "Reihenabstand (Dichte)",
  "Run": "Gerade",
  "Running stitch": "Geradstich",
  "Running stitch and satin run towards the end point. Fill starts and ends at the nearest possible row ends (where the rows are shortest).": "Geradstich und Satin verlaufen zum Endpunkt. Füllungen beginnen und enden an den nächstmöglichen Reihenenden (wo die Reihen am kürzesten sind).",
  "SVG – vector import": "SVG – Vektorimport",
  "Satin": "Satin",
  "Satin column": "Satinsäule",
  "Satin line": "Satinlinie",
  "Satin needs a shape without holes. Use fill stitch, or draw a satin column.": "Satin benötigt eine Form ohne Löcher. Verwenden Sie Füllstich oder zeichnen Sie eine Satinsäule.",
  "Satin up to": "Satin bis",
  "Satin {n}": "Satin {n}",
  "Save": "Speichern",
  "Save current project": "Aktuelles Projekt speichern",
  "Save locally": "Lokal speichern",
  "Save what you are working on and it will show up here.": "Speichern Sie Ihre Arbeit, dann erscheint sie hier.",
  "Scale (Shift = keep proportions)": "Skalieren (Umschalt = Proportionen beibehalten)",
  "Scaling changes the shapes; the stitch density is kept, so the stitch count changes.": "Skalieren ändert die Formen; die Stichdichte bleibt erhalten, daher ändert sich die Stichzahl.",
  "Select": "Auswählen",
  "Select an object on the canvas or in the object list to change its shape, colour and stitches. Draw new shapes with the tools on the left.": "Wählen Sie ein Objekt auf der Arbeitsfläche oder in der Objektliste, um Form, Farbe und Stiche zu ändern. Zeichnen Sie neue Formen mit den Werkzeugen links.",
  "Select and move": "Auswählen und verschieben",
  "Select objects with this colour": "Objekte mit dieser Farbe auswählen",
  "Separate again": "Erneut trennen",
  "Settings": "Einstellungen",
  "Sew connections shorter than": "Verbindungen sticken, die kürzer sind als",
  "Sew earlier": "Früher sticken",
  "Sew later": "Später sticken",
  "Sew simulation": "Sticksimulation",
  "Sew this colour": "Diese Farbe sticken",
  "Sewing time": "Stickzeit",
  "Sewing time (estimate)": "Stickzeit (Schätzung)",
  "Shape": "Form",
  "Shapes": "Formen",
  "Shield": "Wappen",
  "Short stitches in tight curves": "Kurze Stiche in engen Kurven",
  "Show": "Anzeigen",
  "Show (sew)": "Einblenden (sticken)",
  "Show at actual size": "In tatsächlicher Größe anzeigen",
  "Show jumps and trims": "Sprünge und Schnitte anzeigen",
  "Show – the object is sewn and exported again": "Einblenden – das Objekt wird wieder gestickt und exportiert",
  "Size": "Größe",
  "Smallest detail": "Kleinstes Detail",
  "Smoothing": "Glättung",
  "Speed": "Geschwindigkeit",
  "Split wide stitches": "Breite Stiche teilen",
  "Stagger (rows)": "Versatz (Reihen)",
  "Start a new embroidery design": "Neues Stickdesign beginnen",
  "Start, end and tie-off": "Start, Ende und Vernähen",
  "Statistics": "Statistik",
  "Stitch angle": "Stichwinkel",
  "Stitch choices": "Sticheinstellungen",
  "Stitch error: {error}": "Stichfehler: {error}",
  "Stitch generation failed: {error}. Simplify the shape or change the stitch type.": "Stichberechnung fehlgeschlagen: {error}. Vereinfachen Sie die Form oder ändern Sie die Stichart.",
  "Stitch length": "Stichlänge",
  "Stitch position": "Stichposition",
  "Stitch simulation": "Stichsimulation",
  "Stitch type": "Stichart",
  "Stitch type for all": "Stichart für alle",
  "Stitches": "Stiche",
  "Tajima and most industrial machines": "Tajima und die meisten Industriemaschinen",
  "Tatami underlay (90°)": "Tatami-Unterlage (90°)",
  "Text in SVG is not supported. Convert the text to outlines (Object → Object to Path) before importing.": "Text in SVG wird nicht unterstützt. Wandeln Sie den Text vor dem Import in Konturen um (Objekt → Objekt in Pfad).",
  "The DST file is missing the end command (0xF3).": "Der DST-Datei fehlt der Endbefehl (0xF3).",
  "The DST file is shorter than its header (512 bytes).": "Die DST-Datei ist kürzer als ihr Header (512 Byte).",
  "The DST header is missing the LA field.": "Dem DST-Header fehlt das LA-Feld.",
  "The EXP file has an odd number of bytes.": "Die EXP-Datei hat eine ungerade Anzahl Bytes.",
  "The JEF file is missing the end code (0x80 0x10).": "Der JEF-Datei fehlt der Endcode (0x80 0x10).",
  "The PEC section is missing \"LA:\".": "Dem PEC-Abschnitt fehlt \"LA:\".",
  "The PEC stitch block is missing the end code (0xFF).": "Dem PEC-Stichblock fehlt der Endcode (0xFF).",
  "The SVG drawing has no size.": "Die SVG-Zeichnung hat keine Größe.",
  "The SVG file could not be drawn. External resources and scripts are not supported.": "Die SVG-Datei konnte nicht gezeichnet werden. Externe Ressourcen und Skripte werden nicht unterstützt.",
  "The SVG file could not be read.": "Die SVG-Datei konnte nicht gelesen werden.",
  "The SVG file could not be read. Check that it is valid.": "Die SVG-Datei konnte nicht gelesen werden. Prüfen Sie, ob sie gültig ist.",
  "The SVG shapes have neither fill nor stroke.": "Die SVG-Formen haben weder Füllung noch Kontur.",
  "The VP3 design block is corrupt.": "Der VP3-Designblock ist beschädigt.",
  "The VP3 design block is missing xxPP.": "Dem VP3-Designblock fehlt xxPP.",
  "The VP3 file block is longer than the file.": "Der VP3-Dateiblock ist länger als die Datei.",
  "The background is filled with stitches. Sew on stabilizer and cut out along the edge.": "Der Hintergrund wird mit Stichen gefüllt. Auf Stickvlies sticken und am Rand ausschneiden.",
  "The browser cannot draw the image (Canvas is missing).": "Der Browser kann das Bild nicht zeichnen (Canvas fehlt).",
  "The design ({w} × {h} mm) is larger than the hoop {hoop}. Scale the design down or choose a larger hoop.": "Das Design ({w} × {h} mm) ist größer als der Rahmen {hoop}. Verkleinern Sie das Design oder wählen Sie einen größeren Rahmen.",
  "The design has a very large number of stitches ({n}). Many machines limit the stitch count; consider a lower density.": "Das Design hat sehr viele Stiche ({n}). Viele Maschinen begrenzen die Stichzahl; erwägen Sie eine geringere Dichte.",
  "The design has errors that must be fixed before export:": "Das Design hat Fehler, die vor dem Export behoben werden müssen:",
  "The design has no stitches to export. Add objects or digitize an image.": "Das Design hat keine Stiche zum Exportieren. Fügen Sie Objekte hinzu oder digitalisieren Sie ein Bild.",
  "The design has {n} stitches (max {max}). Make the design smaller or increase the row spacing.": "Das Design hat {n} Stiche (max. {max}). Verkleinern Sie das Design oder erhöhen Sie den Reihenabstand.",
  "The design is empty. The patch is created anyway, but import or draw the motif first to fit the size.": "Das Design ist leer. Der Aufnäher wird trotzdem erstellt, aber importieren oder zeichnen Sie zuerst das Motiv, um die Größe anzupassen.",
  "The design is too large for {format}.": "Das Design ist zu groß für {format}.",
  "The design is too large for {format}: coordinate ({x} mm, {y} mm) exceeds the format limit of ±{max} mm.": "Das Design ist zu groß für {format}: Koordinate ({x} mm, {y} mm) überschreitet die Formatgrenze von ±{max} mm.",
  "The design width must be greater than 0 mm.": "Die Designbreite muss größer als 0 mm sein.",
  "The file is empty.": "Die Datei ist leer.",
  "The file is not a StitchCraft project.": "Die Datei ist kein StitchCraft-Projekt.",
  "The file is {size} MB. The maximum size is {max} MB – save the image at a lower resolution.": "Die Datei ist {size} MB groß. Die Höchstgröße ist {max} MB – speichern Sie das Bild in geringerer Auflösung.",
  "The hoop must have a positive width and height.": "Der Rahmen muss eine positive Breite und Höhe haben.",
  "The image could not be decoded. The file may be damaged.": "Das Bild konnte nicht dekodiert werden. Die Datei ist möglicherweise beschädigt.",
  "The image could not be read: {error}": "Das Bild konnte nicht gelesen werden: {error}",
  "The image has no visible content after transparency and background were removed. Turn off background removal or choose another image.": "Das Bild hat nach Entfernen von Transparenz und Hintergrund keinen sichtbaren Inhalt. Schalten Sie die Hintergrundentfernung aus oder wählen Sie ein anderes Bild.",
  "The image is empty.": "Das Bild ist leer.",
  "The image is too large ({w} × {h} pixels). The maximum is {max} megapixels.": "Das Bild ist zu groß ({w} × {h} Pixel). Das Maximum ist {max} Megapixel.",
  "The image is {w} × {h} pixels. The maximum is {max} megapixels.": "Das Bild hat {w} × {h} Pixel. Das Maximum ist {max} Megapixel.",
  "The image was added as a background. Draw shapes on top with the tools (polygon, line, rectangle …).": "Das Bild wurde als Hintergrund eingefügt. Zeichnen Sie Formen darüber mit den Werkzeugen (Polygon, Linie, Rechteck …).",
  "The line needs at least two points.": "Die Linie benötigt mindestens zwei Punkte.",
  "The object produced no stitches. The shape may be too small for the selected stitch type.": "Das Objekt hat keine Stiche erzeugt. Die Form ist möglicherweise zu klein für die gewählte Stichart.",
  "The order below is the sewing order of the colours. Change a colour to move the borders between the colour areas.": "Die Reihenfolge unten ist die Stickreihenfolge der Farben. Ändern Sie eine Farbe, um die Grenzen zwischen den Farbbereichen zu verschieben.",
  "The original image in the project could not be read. The design was opened without an image.": "Das Originalbild im Projekt konnte nicht gelesen werden. Das Design wurde ohne Bild geöffnet.",
  "The outer edge of the satin border is the edge of the patch. Actual size: {w} × {h} mm.": "Die Außenkante des Satinrands ist die Kante des Aufnähers. Tatsächliche Größe: {w} × {h} mm.",
  "The outline crosses itself. It is interpreted with the even-odd rule; fix the nodes for a predictable result.": "Die Kontur überschneidet sich selbst. Sie wird nach der Gerade-Ungerade-Regel ausgewertet; korrigieren Sie die Knoten für ein vorhersehbares Ergebnis.",
  "The palette is empty. Digitize an image or add a colour.": "Die Palette ist leer. Digitalisieren Sie ein Bild oder fügen Sie eine Farbe hinzu.",
  "The project file has no valid version number.": "Die Projektdatei hat keine gültige Versionsnummer.",
  "The project file is not valid JSON.": "Die Projektdatei ist kein gültiges JSON.",
  "The project file is too large.": "Die Projektdatei ist zu groß.",
  "The project was made with a newer version (format {v}). Update StitchCraft to open it.": "Das Projekt wurde mit einer neueren Version erstellt (Format {v}). Aktualisieren Sie StitchCraft, um es zu öffnen.",
  "The satin column is too short to produce stitches.": "Die Satinsäule ist zu kurz, um Stiche zu erzeugen.",
  "The satin column needs two rails with at least two points each.": "Die Satinsäule benötigt zwei Schienen mit jeweils mindestens zwei Punkten.",
  "The satin is up to {width} mm wide (max {max} mm). Enable splitting, make the shape narrower or use fill stitch.": "Der Satin ist bis zu {width} mm breit (max. {max} mm). Aktivieren Sie die Teilung, machen Sie die Form schmaler oder verwenden Sie Füllstich.",
  "The sewing time is a rough estimate based on the speed, colour changes and trims above. The actual time depends on the machine.": "Die Stickzeit ist eine grobe Schätzung anhand von Geschwindigkeit, Farbwechseln und Schnitten oben. Die tatsächliche Zeit hängt von der Maschine ab.",
  "The shape has no area. Delete the object or draw the shape again.": "Die Form hat keine Fläche. Löschen Sie das Objekt oder zeichnen Sie die Form neu.",
  "The shape is too narrow for fill stitch at this row spacing. Use satin or running stitch.": "Die Form ist für Füllstich bei diesem Reihenabstand zu schmal. Verwenden Sie Satin oder Geradstich.",
  "The shape is too narrow for underlay; underlay was left out.": "Die Form ist für eine Unterlage zu schmal; die Unterlage wurde weggelassen.",
  "The shape must have at least {n} points.": "Die Form muss mindestens {n} Punkte haben.",
  "The shapes in the SVG file are imported directly as editable curves: filled shapes become fill, and strokes become running stitch or satin. This gives the most precise edges. The colour settings below apply only to pixel-based digitizing.": "Die Formen der SVG-Datei werden direkt als bearbeitbare Kurven importiert: Gefüllte Formen werden zu Füllungen, Konturen zu Geradstich oder Satin. Das ergibt die präzisesten Kanten. Die Farbeinstellungen unten gelten nur für die pixelbasierte Digitalisierung.",
  "This browser does not support local storage (IndexedDB).": "Dieser Browser unterstützt keinen lokalen Speicher (IndexedDB).",
  "This file type is not supported. Use PNG, JPEG or SVG.": "Dieser Dateityp wird nicht unterstützt. Verwenden Sie PNG, JPEG oder SVG.",
  "Thread (top thread)": "Garn (Oberfaden)",
  "Thread colour": "Garnfarbe",
  "Thread palette": "Garnpalette",
  "Tie-in at start": "Vernähen am Anfang",
  "Tie-off before trims": "Vernähen vor Schnitten",
  "Time per colour change": "Zeit pro Farbwechsel",
  "Time per trim": "Zeit pro Schnitt",
  "Timeline": "Zeitleiste",
  "To end": "Zum Ende",
  "To start": "Zum Anfang",
  "Too many colour changes for PEC (max 255).": "Zu viele Farbwechsel für PEC (max. 255).",
  "Tools": "Werkzeuge",
  "Tracing outlines": "Konturen werden nachgezeichnet",
  "Trim jumps longer than": "Sprünge schneiden, die länger sind als",
  "Trims": "Schnitte",
  "Trims are written as three jumps with no net movement (Tajima convention).": "Schnitte werden als drei Sprünge ohne Nettobewegung geschrieben (Tajima-Konvention).",
  "Truncated EXP control record.": "Abgeschnittener EXP-Steuereintrag.",
  "Underlay": "Unterlage",
  "Undo": "Rückgängig",
  "Unexpected PEC icon format.": "Unerwartetes PEC-Symbolformat.",
  "Unexpected PES v6 header.": "Unerwarteter PES-v6-Header.",
  "Unexpected end of file at byte {pos}": "Unerwartetes Dateiende bei Byte {pos}",
  "Unknown": "Unbekannt",
  "Unknown EXP control code 0x{code}.": "Unbekannter EXP-Steuercode 0x{code}.",
  "Unknown JEF control code 0x{code}.": "Unbekannter JEF-Steuercode 0x{code}.",
  "Unknown SVG path command “{cmd}”.": "Unbekannter SVG-Pfadbefehl „{cmd}“.",
  "Unknown VP3 control code 0x{code}.": "Unbekannter VP3-Steuercode 0x{code}.",
  "Unlock": "Entsperren",
  "Unsaved changes": "Ungespeicherte Änderungen",
  "Untitled": "Unbenannt",
  "Update patch": "Aufnäher aktualisieren",
  "Updating stitches…": "Stiche werden aktualisiert…",
  "Updating the stitches …": "Die Stiche werden aktualisiert …",
  "Use PES v1 if an older machine or program cannot open the file.": "Verwenden Sie PES v1, wenn eine ältere Maschine oder ein älteres Programm die Datei nicht öffnen kann.",
  "Use satin on narrow areas": "Satin für schmale Bereiche verwenden",
  "VP3 export does not support stops without a colour change.": "Der VP3-Export unterstützt keine Stopps ohne Farbwechsel.",
  "VP3 has no jump command; moves are stored as long displacements (normally right after a trim).": "VP3 hat keinen Sprungbefehl; Bewegungen werden als lange Verschiebungen gespeichert (normalerweise direkt nach einem Schnitt).",
  "VP3 with {n} designs is not supported.": "VP3 mit {n} Designs wird nicht unterstützt.",
  "Validate and download .{ext}": "Prüfen und .{ext} herunterladen",
  "Validation of {format} failed: {details}.": "Prüfung von {format} fehlgeschlagen: {details}.",
  "Verification read of {format} failed: {error}": "Kontrolllesen von {format} fehlgeschlagen: {error}",
  "Very wide strokes are sewn as 12 mm satin. Convert them to filled shapes for a better result.": "Sehr breite Konturen werden als 12-mm-Satin gestickt. Wandeln Sie sie für ein besseres Ergebnis in gefüllte Formen um.",
  "View": "Ansicht",
  "Warning": "Warnung",
  "Wide sections (up to {width} mm) are split into several stitches.": "Breite Abschnitte (bis {width} mm) werden in mehrere Stiche geteilt.",
  "Width": "Breite",
  "Width (line)": "Breite (Linie)",
  "Width (stitches)": "Breite (Stiche)",
  "Your work has been restored from your last session.": "Ihre Arbeit wurde aus der letzten Sitzung wiederhergestellt.",
  "Zigzag spacing (same side)": "Zickzack-Abstand (gleiche Seite)",
  "Zigzag underlay": "Zickzack-Unterlage",
  "Zoom": "Zoom",
  "Zoom in (+)": "Vergrößern (+)",
  "Zoom out (−)": "Verkleinern (−)",
  "colour change": "Farbwechsel",
  "colour changes differ ({e} vs {a})": "Farbwechsel weichen ab ({e} statt {a})",
  "colour {i} is invalid": "Farbe {i} ist ungültig",
  "crop": "Zuschnitt",
  "design is missing": "Design fehlt",
  "design is missing objects or palette": "Dem Design fehlen Objekte oder Palette",
  "end": "Ende",
  "estimate": "Schätzung",
  "fill": "Füllung",
  "height": "Höhe",
  "id is missing": "ID fehlt",
  "image data is invalid": "Bilddaten sind ungültig",
  "invalid": "ungültig",
  "jump": "Sprung",
  "locked": "gesperrt",
  "missing": "fehlt",
  "move {i}: expected ({ex}, {ey}{ej}), found ({ax}, {ay}{aj})": "Bewegung {i}: erwartet ({ex}, {ey}{ej}), gefunden ({ax}, {ay}{aj})",
  "not sewn": "nicht gestickt",
  "number of moves: expected {e}, found {a}": "Anzahl Bewegungen: erwartet {e}, gefunden {a}",
  "object {i} has an invalid shape": "Objekt {i} hat eine ungültige Form",
  "object {i} has no id/colour": "Objekt {i} hat keine ID/Farbe",
  "object {i} has no transform": "Objekt {i} hat keine Transformation",
  "object {i} is invalid": "Objekt {i} ist ungültig",
  "open": "offen",
  "rotation": "Drehung",
  "running stitch": "Geradstich",
  "satin": "Satin",
  "scale": "Skalierung",
  "stitch": "Stich",
  "stitch parameters are missing": "Stichparameter fehlen",
  "stop": "Stopp",
  "trim": "Schnitt",
  "trims differ ({e} vs {a})": "Schnitte weichen ab ({e} statt {a})",
  "unknown image type {mime}": "unbekannter Bildtyp {mime}",
  "unknown stitch type {type}": "unbekannte Stichart {type}",
  "was written, read back and checked against the internal stitch sequence.": "wurde geschrieben, zurückgelesen und mit der internen Stichfolge abgeglichen.",
  "width": "Breite",
  "{h} h {m} min": "{h} h {m} min",
  "{kind} · no. {n} of {total} in the sewing order · {stitches} stitches": "{kind} · Nr. {n} von {total} in der Stickreihenfolge · {stitches} Stiche",
  "{label} must be between {min} and {max}{unit} (is {value}).": "{label} muss zwischen {min} und {max}{unit} liegen (ist {value}).",
  "{m} min {s} s": "{m} min {s} s",
  "{name} (copy)": "{name} (Kopie)",
  "{name} · {type} · {n} stitches": "{name} · {type} · {n} Stiche",
  "{n} cmd/s": "{n} Bef./s",
  "{n} error(s)": "{n} Fehler",
  "{n} hidden object ({names}) is not in the file. Show it in the object list if it should be sewn.": "{n} ausgeblendetes Objekt ({names}) ist nicht in der Datei. Blenden Sie es in der Objektliste ein, wenn es gestickt werden soll.",
  "{n} hidden objects ({names}) are not in the file. Show them in the object list if they should be sewn.": "{n} ausgeblendete Objekte ({names}) sind nicht in der Datei. Blenden Sie sie in der Objektliste ein, wenn sie gestickt werden sollen.",
  "{n} hidden – not sewn": "{n} ausgeblendet – nicht gestickt",
  "{n} objects": "{n} Objekte",
  "{n} objects selected": "{n} Objekte ausgewählt",
  "{n} points · Enter/double-click finishes · Backspace removes a point · Esc cancels": "{n} Punkte · Enter/Doppelklick beendet · Rücktaste entfernt einen Punkt · Esc bricht ab",
  "{n} problem(s) in the design must be fixed before export.": "{n} Problem(e) im Design müssen vor dem Export behoben werden.",
  "{n} small areas were merged.": "{n} kleine Bereiche wurden zusammengeführt.",
  "{n} warning(s)": "{n} Warnung(en)",
  "{s} s": "{s} s",
  "{what} must be a number": "{what} muss eine Zahl sein",
  "“{name}” is saved locally in the browser.": "„{name}“ ist lokal im Browser gespeichert.",
  "“{name}” uses a colour that is not in the palette. Choose a new colour.": "„{name}“ verwendet eine Farbe, die nicht in der Palette ist. Wählen Sie eine neue Farbe.",
  "New": "Neu",
  "Start a new project?": "Neues Projekt beginnen?",
  "“{name}” has unsaved changes. Do you want to save them before you start a new project?": "„{name}“ hat ungespeicherte Änderungen. Möchten Sie sie speichern, bevor Sie ein neues Projekt beginnen?",
  "Discard changes": "Änderungen verwerfen",
  "Save and start new": "Speichern und neu beginnen",
  "Enter saves · Esc cancels": "Enter speichert · Esc bricht ab",
  "Measure": "Messen",
  "Length {len} mm ({inch} in) · Δx {dx} mm · Δy {dy} mm · angle {angle}°": "Länge {len} mm ({inch} Zoll) · Δx {dx} mm · Δy {dy} mm · Winkel {angle}°",
  "Click two points to measure · Shift = 15° steps · snaps to nodes · Esc clears": "Zwei Punkte anklicken zum Messen · Umschalt = 15°-Schritte · rastet an Knoten ein · Esc löscht",
  "Embroidery machine": "Stickmaschine",
  "Generic (all hoop sizes)": "Allgemein (alle Rahmengrößen)",
  "Only the hoops this machine accepts are shown. Check the sizes against the manual for your machine.": "Es werden nur die Rahmen angezeigt, die diese Maschine verwendet. Prüfen Sie die Größen anhand der Anleitung Ihrer Maschine.",
  "File name": "Dateiname",
  "Change the name in the top bar.": "Ändern Sie den Namen in der oberen Leiste.",
  "Import an image (PNG, JPEG or SVG) for automatic digitizing, or draw shapes yourself with the tools below.": "Importieren Sie ein Bild (PNG, JPEG oder SVG) zur automatischen Digitalisierung oder zeichnen Sie Formen selbst mit den Werkzeugen unten.",
  "Menu": "Menü",
  "Import": "Importieren",
  "More": "Mehr",
  "Simulate": "Simulieren",
  "Delete node": "Knoten löschen",
  "Copy": "Kopieren",
  "Cut": "Ausschneiden",
  "Paste": "Einfügen",
  "A new code is on its way to {email}. You can ask for a new code once a minute.": "Ein neuer Code ist unterwegs an {email}. Sie können einmal pro Minute einen neuen Code anfordern.",
  "A test email is sent to {email}.": "Eine Testnachricht wurde an {email} gesendet.",
  "Account": "Konto",
  "Account: {email}": "Konto: {email}",
  "Accounts are not available on this server.": "Konten sind auf diesem Server nicht verfügbar.",
  "Active": "Aktiv",
  "Administration": "Verwaltung",
  "Administrator": "Administrator",
  "Back to log in": "Zurück zur Anmeldung",
  "Block": "Sperren",
  "Blocked": "Gesperrt",
  "Brevo API key": "Brevo-API-Schlüssel",
  "Change password": "Passwort ändern",
  "Choose a new password": "Neues Passwort wählen",
  "Code from the email": "Code aus der E-Mail",
  "Confirm": "Bestätigen",
  "Confirm your email address": "E-Mail-Adresse bestätigen",
  "Confirm your email address first. Enter the code we sent you.": "Bestätigen Sie zuerst Ihre E-Mail-Adresse. Geben Sie den Code ein, den wir Ihnen gesendet haben.",
  "Create account": "Konto erstellen",
  "Create an account": "Konto erstellen",
  "Created {date}": "Erstellt am {date}",
  "Current password": "Aktuelles Passwort",
  "Delete user": "Benutzer löschen",
  "Delete {email} and their cloud projects": "{email} und die Cloud-Projekte löschen",
  "Email": "E-Mail",
  "Emails (codes for confirming addresses and resetting passwords) are sent with Brevo.": "E-Mails (Codes zum Bestätigen von Adressen und Zurücksetzen von Passwörtern) werden mit Brevo gesendet.",
  "Enter a valid email address.": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "Forgot password": "Passwort vergessen",
  "Forgot password?": "Passwort vergessen?",
  "If {email} has an account, we have sent a code to it.": "Falls {email} ein Konto hat, haben wir einen Code dorthin gesendet.",
  "In the cloud": "In der Cloud",
  "In this browser": "In diesem Browser",
  "Log in": "Anmelden",
  "Log out": "Abmelden",
  "Logged in as {email}.": "Angemeldet als {email}.",
  "Make admin": "Zum Administrator machen",
  "Member since": "Mitglied seit",
  "New password": "Neues Passwort",
  "New password (at least {n} characters)": "Neues Passwort (mindestens {n} Zeichen)",
  "No API key: emails cannot be sent.": "Kein API-Schlüssel: E-Mails können nicht gesendet werden.",
  "No connection to the server.": "Keine Verbindung zum Server.",
  "Not confirmed": "Nicht bestätigt",
  "Not found.": "Nicht gefunden.",
  "Password": "Passwort",
  "Password (at least {n} characters)": "Passwort (mindestens {n} Zeichen)",
  "Remove admin role": "Administratorrolle entfernen",
  "Remove the stored key": "Gespeicherten Schlüssel entfernen",
  "Role": "Rolle",
  "Save new password": "Neues Passwort speichern",
  "Search by email": "Nach E-Mail suchen",
  "Send a new code": "Neuen Code senden",
  "Send a test email to {email}": "Testnachricht an {email} senden",
  "Send code": "Code senden",
  "Sender address": "Absenderadresse",
  "Sender name": "Absendername",
  "Show more": "Mehr anzeigen",
  "Something went wrong on the server. Try again.": "Auf dem Server ist ein Fehler aufgetreten. Versuchen Sie es erneut.",
  "Stored ({hint}) – leave empty to keep it": "Gespeichert ({hint}) – leer lassen, um ihn zu behalten",
  "Superadmin": "Superadmin",
  "The API key comes from the server environment (BREVO_API_KEY).": "Der API-Schlüssel stammt aus der Serverumgebung (BREVO_API_KEY).",
  "The API key is stored here (encrypted).": "Der API-Schlüssel ist hier gespeichert (verschlüsselt).",
  "The code has expired. Ask for a new code.": "Der Code ist abgelaufen. Fordern Sie einen neuen Code an.",
  "The code is not correct.": "Der Code ist nicht korrekt.",
  "The email could not be sent. Try again later or contact the administrator.": "Die E-Mail konnte nicht gesendet werden. Versuchen Sie es später erneut oder wenden Sie sich an den Administrator.",
  "The email could not be sent: {detail}": "Die E-Mail konnte nicht gesendet werden: {detail}",
  "The email settings are saved.": "Die E-Mail-Einstellungen sind gespeichert.",
  "The password is changed. Other devices are logged out.": "Das Passwort ist geändert. Andere Geräte wurden abgemeldet.",
  "The password must be at least {n} characters.": "Das Passwort muss mindestens {n} Zeichen haben.",
  "The project could not be stored.": "Das Projekt konnte nicht gespeichert werden.",
  "The project is too large to store in the cloud.": "Das Projekt ist zu groß für die Cloud.",
  "The sender address must be a verified sender or domain in Brevo.": "Die Absenderadresse muss ein bestätigter Absender oder eine bestätigte Domain in Brevo sein.",
  "This account is blocked. Contact the administrator.": "Dieses Konto ist gesperrt. Wenden Sie sich an den Administrator.",
  "Too many attempts. Wait a little and try again.": "Zu viele Versuche. Warten Sie kurz und versuchen Sie es erneut.",
  "Too many wrong attempts. Ask for a new code.": "Zu viele Fehlversuche. Fordern Sie einen neuen Code an.",
  "Unblock": "Entsperren",
  "User": "Benutzer",
  "Users": "Benutzer",
  "We have sent a code to {email}. If the address already has an account, log in instead.": "Wir haben einen Code an {email} gesendet. Hat die Adresse bereits ein Konto, melden Sie sich stattdessen an.",
  "With an account you can store projects in the cloud and open them on other devices. Without one, StitchCraft works as before, in this browser only.": "Mit einem Konto können Sie Projekte in der Cloud speichern und auf anderen Geräten öffnen. Ohne Konto funktioniert StitchCraft wie bisher, nur in diesem Browser.",
  "Wrong email or password.": "Falsche E-Mail-Adresse oder falsches Passwort.",
  "You are logged out. Projects in this browser are still here.": "Sie sind abgemeldet. Die Projekte in diesem Browser bleiben erhalten.",
  "You are not logged in.": "Sie sind nicht angemeldet.",
  "You do not have access to this.": "Sie haben keinen Zugriff darauf.",
  "You have reached the maximum number of cloud projects. Delete some first.": "Sie haben die maximale Anzahl an Cloud-Projekten erreicht. Löschen Sie zuerst einige.",
  "Your email address is not confirmed yet. We have sent a new code to {email}.": "Ihre E-Mail-Adresse ist noch nicht bestätigt. Wir haben einen neuen Code an {email} gesendet.",
  "last logged in {date}": "zuletzt angemeldet {date}",
  "never logged in": "nie angemeldet",
  "{n} cloud projects": "{n} Cloud-Projekte",
  "{n} users": "{n} Benutzer",
  "“{name}” is saved in the browser and in the cloud.": "„{name}“ ist im Browser und in der Cloud gespeichert.",
  "“{name}” is saved in the browser, but not in the cloud: {error}": "„{name}“ ist im Browser gespeichert, aber nicht in der Cloud: {error}",
  "“{name}” is saved in the cloud.": "„{name}“ ist in der Cloud gespeichert.",
  "1 user": "1 Benutzer",
  "Hide this tip": "Hinweis ausblenden",
  "While you are logged in, everything you save is stored in the cloud and can be opened on all your devices.": "Solange Sie angemeldet sind, wird alles, was Sie speichern, in der Cloud abgelegt und kann auf all Ihren Geräten geöffnet werden.",
  "You are logged in as {email}: projects are saved in the cloud, with a copy in this browser.": "Sie sind als {email} angemeldet: Projekte werden in der Cloud gespeichert, mit einer Kopie in diesem Browser.",
  "Projects are saved in this browser.": "Projekte werden in diesem Browser gespeichert.",
  "Log in to save them in the cloud.": "Melden Sie sich an, um sie in der Cloud zu speichern.",
  "{n} projects are only in this browser.": "{n} Projekte liegen nur in diesem Browser.",
  "Upload them to the cloud": "In die Cloud hochladen",
  "The folder is empty": "Der Ordner ist leer",
  "Move projects here with “Move to folder”, or save the current project while the folder is open.": "Verschieben Sie Projekte mit „In Ordner verschieben“ hierher, oder speichern Sie das aktuelle Projekt, während der Ordner geöffnet ist.",
  "Folders": "Ordner",
  "All projects": "Alle Projekte",
  "No folder": "Ohne Ordner",
  "New folder": "Neuer Ordner",
  "Folder name": "Ordnername",
  "Create": "Erstellen",
  "Rename folder": "Ordner umbenennen",
  "Delete the folder (the projects are kept)": "Ordner löschen (die Projekte bleiben erhalten)",
  "Delete folder": "Ordner löschen",
  "Move to folder": "In Ordner verschieben",
  "Delete everywhere": "Überall löschen",
  "Only from this browser": "Nur aus diesem Browser",
  "Only from the cloud": "Nur aus der Cloud",
  "Upload to the cloud": "In die Cloud hochladen",
  "More actions for {name}": "Weitere Aktionen für {name}",
  "Make a copy": "Kopie erstellen",
  "Delete “{name}”": "„{name}“ löschen",
};
